import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ProvisionService } from 'src/services/provision/provision.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'conversion-breakdown',
  templateUrl: './breakdownsettings.component.html',
})
export class BreakdownSettingsComponent implements OnInit {
  startobject = 'EP:1';
  timeValidity = false;

  constructor(private provisionService: ProvisionService) {}

  ngOnInit(): void {
    this.startobject = this.provisionService.getStartObject();
    this.timeValidity = this.provisionService.getValidityFlag();
  }

  setStartObject(value: string) { this.provisionService.insertStartObject(value); }
  setTimeValidity(value: boolean) { this.provisionService.insertValidityFlag(value); }
}
